module.exports = __webpack_public_path__ + "static/8-8c5f0c69b63d31f97fb99d567ede8c1c.png";